import { minutesToSeconds } from 'date-fns';

import { PatchedPayerOrganizationSettings } from 'src/common/external/bambi-api/bambiApi';

import { FormValues } from './FormValues';
import { payerRequiredTripFieldOptionToValue } from './payerRequiredTripFieldOptionToValue';
import { payerSignatureOptionToPayerSignature } from './payerSignatureOptionToPayerSignature';

export const payerOrgToPatchedPayerOrgSettings = (
  payerOrg: FormValues
): PatchedPayerOrganizationSettings => {
  return {
    _pickup_default_early_seconds: payerOrg.pickup_default_early_seconds
      ? minutesToSeconds(payerOrg.pickup_default_early_seconds)
      : null,
    _pickup_default_late_seconds: payerOrg.pickup_default_late_seconds
      ? minutesToSeconds(payerOrg.pickup_default_late_seconds)
      : null,
    _pickup_appointment_early_seconds: payerOrg.pickup_appointment_early_seconds
      ? minutesToSeconds(payerOrg.pickup_appointment_early_seconds)
      : null,
    _pickup_appointment_late_seconds: payerOrg.pickup_appointment_late_seconds
      ? minutesToSeconds(payerOrg.pickup_appointment_late_seconds)
      : null,
    _pickup_will_call_early_seconds: payerOrg.pickup_will_call_early_seconds
      ? minutesToSeconds(payerOrg.pickup_will_call_early_seconds)
      : null,
    _pickup_will_call_late_seconds: payerOrg.pickup_will_call_late_seconds
      ? minutesToSeconds(payerOrg.pickup_will_call_late_seconds)
      : null,
    _extra_scheduled_pickup_at_seconds:
      payerOrg.extra_scheduled_pickup_at_seconds
        ? minutesToSeconds(payerOrg.extra_scheduled_pickup_at_seconds)
        : null,
    invoice_due_after_days: payerOrg.invoice_due_after_days || null,
    _requires_signature_pickup_passenger: payerSignatureOptionToPayerSignature(
      payerOrg.requires_signature_pickup_passenger
    ),
    _requires_signature_dropoff_passenger: payerSignatureOptionToPayerSignature(
      payerOrg.requires_signature_dropoff_passenger
    ),
    _requires_signature_pickup_driver: payerSignatureOptionToPayerSignature(
      payerOrg.requires_signature_pickup_driver
    ),
    _requires_signature_dropoff_driver: payerSignatureOptionToPayerSignature(
      payerOrg.requires_signature_dropoff_driver
    ),
    trip_required_fields: {
      _passenger_phone_number: payerRequiredTripFieldOptionToValue(
        payerOrg.trip_required_fields.passenger_phone_number
      ),
      _passenger_weight: payerRequiredTripFieldOptionToValue(
        payerOrg.trip_required_fields.passenger_weight
      ),
      _authorization_id: payerRequiredTripFieldOptionToValue(
        payerOrg.trip_required_fields.authorization_id
      ),
      _insurance_policy_id: payerRequiredTripFieldOptionToValue(
        payerOrg.trip_required_fields.insurance_policy_id
      ),
      _payer_passenger_external_id: payerRequiredTripFieldOptionToValue(
        payerOrg.trip_required_fields.payer_passenger_external_id
      ),
      _external_trip_id: payerRequiredTripFieldOptionToValue(
        payerOrg.trip_required_fields.external_trip_id
      ),
      _booked_by_name: payerRequiredTripFieldOptionToValue(
        payerOrg.trip_required_fields.booked_by_name
      ),
      _booked_by_phone_number: payerRequiredTripFieldOptionToValue(
        payerOrg.trip_required_fields.booked_by_phone_number
      ),
    },
    allow_only_specific_drivers: payerOrg.allow_only_specific_drivers,
    allowed_driver_ids: payerOrg.allowed_drivers,
    allow_only_specific_vehicles: payerOrg.allow_only_specific_vehicles,
    allowed_vehicle_ids: payerOrg.allowed_vehicles,
  };
};
